// The canonical precedence for a data view's four states, shared by the calendar
// surfaces (Voting / Create-Edit / Dashboard / Availability) so the ordering is
// defined + tested in ONE place instead of being re-encoded in each page's JSX
// gate (where it was previously "asserted by nothing").
//
// Precedence: loading wins (never show error/empty mid-load) → then error (a
// failed load is NOT "nothing here") → then empty → else ready. Pass
// `isEmpty: false` (or omit) for surfaces that have no empty concept at this
// layer (they delegate empty to a child component).
//
// @returns {"loading" | "error" | "empty" | "ready"}
export function resolveLoadState({ loading, error, isEmpty } = {}) {
  if (loading) return "loading";
  if (error) return "error";
  if (isEmpty) return "empty";
  return "ready";
}
